/* Each document load starts a fresh session clock. No cookies or storage. */
(() => {
  const boot = root => {
    root.querySelectorAll('[data-ltb-timer]').forEach(timer => {
      if (timer.dataset.started) return;
      timer.dataset.started = 'true';
      const started = Date.now();
      const update = () => {
        const remaining = Math.max(0, 983 - Math.floor((Date.now() - started) / 1000));
        const parts = {days: 0, hours: 0, minutes: Math.floor(remaining / 60), seconds: remaining % 60};
        Object.entries(parts).forEach(([unit, value]) => {
          const el = timer.querySelector('[data-ltb-unit="' + unit + '"]');
          if (el) el.textContent = String(value).padStart(2, '0');
        });
        if (!remaining || !timer.isConnected) clearInterval(handle);
      };
      const handle = setInterval(update, 250);
      update();
    });
  };
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
